import store from '../store';
import actionTypes from './actionTypes';
import { parseApiYaml } from '../../utils/helpers';
import { getApiUrl } from './swaggerApi';

export function setSwaggerUrl(url) {
  store.dispatch({
    type: actionTypes.SET_URL,
    payload: { url },
  });
}

export async function loadDefaultSwaggerApi(item) {
  const url = getApiUrl(item.defaultVersion, item.versions);

  store.dispatch({
    type: actionTypes.LOAD_API,
    payload: { activeApi: item },
  });

  try {
    const result = await fetch(url);
    const text = await result.text();

    const subMenu = parseApiYaml(text);
    store.dispatch({
      type: actionTypes.LOAD_API_SUCCESS,
      payload: { subMenu },
    });
  } catch (e) {
    store.dispatch({
      type: actionTypes.LOAD_API_FAILED,
    });
    console.log(e);
  }
}

export async function updateSwaggerApiVersion(selectedVersion, item) {
  const url = getApiUrl(selectedVersion, item.versions);

  try {
    const result = await fetch(url);
    const text = await result.text();

    const subMenu = parseApiYaml(text);
    store.dispatch({
      type: actionTypes.LOAD_API_SUCCESS,
      payload: { subMenu },
    });
  } catch (e) {
    store.dispatch({
      type: actionTypes.LOAD_API_FAILED,
    });
    console.log(e);
  }
}
